import { useSelector } from 'react-redux'
import { Subscription, SubscriptionStatus } from '@src/types'
import { subscriptionsSelector, userSelector } from '@src/selectors/app'

export const isSubscriptionActive = (subscription: Pick<Subscription, 'status'>) => {
  return (
    subscription.status === SubscriptionStatus.Active ||
    subscription.status === SubscriptionStatus.PastDue ||
    subscription.status === SubscriptionStatus.Trialing
  )
}

export const useActiveSubscriptions = () => {
  const subscriptions = useSelector(subscriptionsSelector)

  return subscriptions.filter((subscription) => isSubscriptionActive(subscription))
}

export const useActiveCoreSubscription = () => {
  const subscriptions = useActiveSubscriptions()
  const user = useSelector(userSelector)
  return subscriptions.find((sub) => sub.id === user?.lastCoreSubscription?.id)
}
